package com.macrofocus.eflux.network

import org.molap.network.AbstractNetwork
import web.svg.SVGSVGElement

abstract class AbstractEFluxNetwork(graphical: GraphicalNetwork) : AbstractNetwork<EFluxNode, EFluxLink>(), EFluxNetwork {
    override val svg : SVGSVGElement = graphical.svg

    override val pointsParent = graphical.pointsParent
    //    val dreibeine = svg.getElementById("Dreibeine") as SVGGraphicsElement
    override val pathsParent = graphical.pathsParent
//    val legendeParent = svg.getElementById("Legende") as SVGGraphicsElement
}